// import React, { useEffect, useState } from "react";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

// import { GetHomeProductList } from "../../../networkCalls";
// import ProductGridBox from "../ProductCels/ProductGridBox";
// import NoProductFound from "../ProductCels/NoProductFound";

// const NewArrivals = () => {
//   const [newArrivalsData, setNewArrivalsData] = useState([]);
//   const [bestSellingData, setBestSellingData] = useState([]);
//   const [trendingData, setTrendingData] = useState([]);

//   const [openSection, setOpenSection] = useState(null);

//   const responsiveCarousel = {
//     0: { items: 1 },
//     450: { items: 1 },
//     600: { items: 2 },
//     1000: { items: 4 },
//   };

//   useEffect(() => {
//     GetHomeProductList().then((res) => {
//       if (res?.data?.status === 1) {
//         setNewArrivalsData(res?.data?.NewArrivals);
//         setBestSellingData(res?.data?.BestSelling);
//         setTrendingData(res?.data?.Trending);
//       }
//     });
//   }, []);

//   return (
//     <div className="product-section-wrapper py-4">
//       <div className="container">

//         {/* New Arrivals */}
//         <SectionCard
//           titleRed="NEW"
//           titleGray="ARRIVALS"
//           isOpen={openSection === 1}
//           onToggle={() => setOpenSection(openSection === 1 ? null : 1)}
//           data={newArrivalsData}
//           responsive={responsiveCarousel}
//         />

//         {/* Best Selling */}
//         <SectionCard
//           titleRed="BEST SELLING"
//           titleGray="PRODUCTS"
//           isOpen={openSection === 2}
//           onToggle={() => setOpenSection(openSection === 2 ? null : 2)}
//           data={bestSellingData}
//           responsive={responsiveCarousel}
//         />

//         {/* Trending */}
//         <SectionCard
//           titleRed="TRENDING"
//           titleGray="PRODUCTS"
//           isOpen={openSection === 3}
//           onToggle={() => setOpenSection(openSection === 3 ? null : 3)}
//           data={trendingData}
//           responsive={responsiveCarousel}
//         />

//       </div>
//     </div>
//   );
// };

// // -------------------------------------------
// // Reusable Section Component
// // -------------------------------------------

// const SectionCard = ({ titleRed, titleGray, isOpen, onToggle, data, responsive }) => {
//   return (
//     <div className="custom-card mb-4">
//       <div className="custom-card-header" onClick={onToggle}>
//         <h4 className="m-0 fw-bold text-uppercase">
//           <span className="text-danger">{titleRed}</span>{" "}
//           <span className="text-dark">{titleGray}</span>
//         </h4>

//         <div className={`plus-btn ${isOpen ? "rotate" : ""}`}>+</div>
//       </div>

//       {/* Collapse Body */}
//       <div className={`custom-card-body ${isOpen ? "open" : ""}`}>
//         {data?.length > 0 ? (
//           <OwlCarousel
//             className="owl-theme mt-3"
//             autoplay={false}
//             nav
//             dots={false}
//             responsive={responsive}
//           >
//             {data?.map((item, index) => (
//               <div className="p-2" key={index}>
//                 <ProductGridBox itemin={item} />
//               </div>
//             ))}
//           </OwlCarousel>
//         ) : (
//           <NoProductFound />
//         )}
//       </div>
//     </div>
//   );
// };

// export default NewArrivals;



import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";


import { GetHomeProductList } from "../../../networkCalls";
import ProductGridBox from "../ProductCels/ProductGridBox";
import NoProductFound from "../ProductCels/NoProductFound";

const NewArrivals = () => {
  const [newArrivalsData, setNewArrivalsData] = useState([]);
  const [bestSellingData, setBestSellingData] = useState([]);
  const [trendingData, setTrendingData] = useState([]);

  // OPEN ALL SECTIONS INDEPENDENTLY
  const [openNew, setOpenNew] = useState(false);
  const [openBest, setOpenBest] = useState(false);
  const [openTrending, setOpenTrending] = useState(false);

  const responsiveCarousel = {
    0: { items: 1 },
    450: { items: 1 },
    600: { items: 2 },
    1000: { items: 5 },
  };

  useEffect(() => {
    GetHomeProductList().then((res) => {
      if (res?.data?.status === 1) {
        setNewArrivalsData(res?.data?.NewArrivals);
        setBestSellingData(res?.data?.BestSelling);
        setTrendingData(res?.data?.Trending);
      }
    });
  }, []);

  return (
    <div className="product-section-wrapper pb-4">
      <div className="container px-0">

        <SectionCard
          titleRed="NEW"
          titleGray="ARRIVALS"
          isOpen={openNew}
          onToggle={() => setOpenNew(!openNew)}
          data={newArrivalsData}
          responsive={responsiveCarousel}
        />

        <SectionCard
          titleRed="BEST SELLING"
          titleGray="PRODUCTS"
          isOpen={openBest}
          onToggle={() => setOpenBest(!openBest)}
          data={bestSellingData}
          responsive={responsiveCarousel}
        />

        <SectionCard
          titleRed="TRENDING"
          titleGray="PRODUCTS"
          isOpen={openTrending}
          onToggle={() => setOpenTrending(!openTrending)}
          data={trendingData}
          responsive={responsiveCarousel}
        />

      </div>
    </div>
  );
};

// -----------------------------

const SectionCard = ({ titleRed, titleGray, isOpen, onToggle, data, responsive }) => {
  return (
    <div className="custom-card mb-4">
      <div className="custom-card-header" onClick={onToggle}>
        <h4 className="m-0 fw-bold text-uppercase">
          <span className="text-danger">{titleRed}</span>{" "}
          <span className="text-dark">{titleGray}</span>
        </h4>

        <button
          className="customcardkey-btn d-flex align-items-center justify-content-center"
         
        >
          <span className={`customcardkey-icon-wrapper ${isOpen ? "customcardkey-rotate" : ""}`}>
            {isOpen ? (
              <RemoveIcon style={{ color: "white" }} />
            ) : (
              <AddIcon style={{ color: "white" }} />
            )}
          </span>
        </button>
      </div>

      <div className={`custom-card-body ${isOpen ? "open" : ""}`}>
        {data?.length > 0 ? (
          <OwlCarousel
            className="owl-theme mt-3"
            autoplay={false}
            nav
            dots={false}
            responsive={responsive}
          >
            {data.map((item, index) => (
              <div className="p-2" key={index}>
                <ProductGridBox itemin={item} />
              </div>
            ))}
          </OwlCarousel>
        ) : (
          <NoProductFound />
        )}
      </div>
    </div>
  );
};

export default NewArrivals;
